import {SwitcherController} from './app-switcher.controller';
import ScrollIfModule from './scroll-if/scroll-if';
import * as angular from 'angular';
import * as template from './app-switcher.html';

function SwitcherDirective() {
    return {
        scope: {},
        restrict: 'E',
        template: template,
        controller: SwitcherController,
        controllerAs: 'ctrl',
        bindToController: {
            state: '='
        }
    };
}

export default angular
    .module('spsng.components.app-switcher', [ScrollIfModule])
    .directive('appSwitcher', SwitcherDirective)
    .name;
